/* eslint-disable react/prop-types */
import React from 'react';
import Question from './Question';

const CSVsForm = ({ projectId, variables, questionnaire }) => {
  const collectionId = 'am_csv';

  const questionsIds = [collectionId];

  questionnaire
    .getChildQuestions(collectionId)
    .forEach((question) => questionsIds.push(question.id));

  questionsIds.forEach((questionId) =>
    questionnaire
      .getChildQuestions(questionId)
      .forEach((question) => questionsIds.push(question.id)),
  );

  return (
    <Question
      projectId={projectId}
      variables={variables}
      questionnaire={questionnaire}
      questionsIds={questionsIds}
      nameId="amb_name"
      hasOrder
    />
  );
};

export default CSVsForm;
